import React from 'react';
import './CategoryPill.scss';

// Individual pill component.
const CategoryPill = ({ text }) => <span className="tenant_pill">{text}</span>;

export default CategoryPill;
